import i18n from '@/i18n';
import store from '@/store';

export const checkForChunkLoadError = async (error: any) => {
  if (error?.name?.includes('ChunkLoadError')) {
    if (window.caches) {
      // Browser supports caches, we can check chunk existence

      const request = await window.caches.match(error.request);
      if (request) {
        return 'unknown';
      }

      // chunk is not in cache => application encountered 404
      return 'notFound';
    }

    return 'unknown';
  }

  return false;
};

const chunkLoadErrorHandler = (event: PromiseRejectionEvent) => {
  checkForChunkLoadError(event.reason).then((result) => {
    if (result === 'notFound') {
      // chunk is not in cache => application encountered 404
      store?.dispatch('notification/add', {
        message: i18n.global.t('notification.chunkLoadError'),
        id: 'chunkload',
        actions: [
          {
            label: i18n.global.t('action.reloadPage'),
            action: () => window.location.reload(),
          },
        ],
      });
    }
  });
};

export const handleChunkLoadError = () => {
  // Display message if js file could not be loaded.
  // Usually happens when a new version was released and the js files
  // of the previous version do not exist anymore
  window.addEventListener('unhandledrejection', chunkLoadErrorHandler);

  window.addEventListener('beforeunload', () => {
    // deregister chunkLoadErrorHandler when page is unloaded, because unloading
    // aborts js file requests
    window.removeEventListener('unhandledrejection', chunkLoadErrorHandler);
  });
};
